<template>
  <svg
    :class="$style.logo"
    width="538"
    height="149"
    viewBox="0 0 538 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <path
      d="M84.9446 83.2765H32.6727V36.2285H0V145.136H32.6727V96.3445H84.9446V145.136H117.617V36.2285H84.9446V83.2765Z"
      fill="black"
    />
    <path d="M346.314 0H312.554L302.545 26.2059H336.304L346.314 0Z" fill="black" />
    <path d="M292.088 26.2059L283.3 0H249.541L258.329 26.2059H292.088Z" fill="black" />
    <path
      d="M150.516 36.2285L121.109 145.136H150.516L158.791 114.642H196.693L204.967 145.136H238.727L209.32 36.2285H150.511H150.516ZM162.277 101.574L177.524 44.9441H177.96L193.207 101.574H162.277Z"
      fill="black"
    />
    <path
      d="M478.102 36.2285L453.273 136.42H452.837L427.788 36.2285H367.893V145.136H396.207V44.9387H396.423L421.472 145.136H480.065L504.894 44.9387H505.33V145.136H538.002V36.2285H478.102Z"
      fill="black"
    />
    <path
      d="M297.104 125.529C277.064 125.529 269.44 115.947 268.354 96.3425H360.055V90.6773C360.055 56.4821 335.006 32.7402 297.11 32.7402C259.213 32.7402 234.379 56.4821 234.379 90.6773C234.379 124.873 259.643 148.614 297.11 148.614C334.576 148.614 355.918 129.446 360.276 106.796H325.645C323.466 120.956 314.32 125.529 297.11 125.529H297.104ZM297.104 55.8311C315.837 55.8311 324.112 64.5414 325.855 83.2745H268.354C269.876 64.5414 277.72 55.8311 297.104 55.8311Z"
      fill="black"
    />
  </svg>
</template>

<style module>
.logo {
  display: block;
  width: 538px;
  height: auto;
  max-width: 100%;
}
</style>
